<template>
     <base-section id="theme-features">
          <base-section-heading title="Let Me Help You Give..." space="0">
          </base-section-heading>

          <v-container>
               <v-row>
                    <v-col
                         v-for="(feature, i) in features"
                         :key="i"
                         cols="12"
                         md="6"
                    >
                         <base-avatar-card
                              v-bind="feature"
                              align="left"
                              horizontal
                         >
                              {{ feature.description }}
                         </base-avatar-card>
                    </v-col>
               </v-row>
          </v-container>
     </base-section>
</template>

<script>
export default {
     name: 'SectionThemeFeatures',

     data: () => ({
          features: [
               {
                    color: 'green lighten-2',
                    dark: true,
                    title: 'The Perfect Gift',
                    icon: 'mdi-gift-outline',
                    description: `The perfect gift is the one you didn't know existed, but once you open it you realize it's what you've always wanted.`,
               },
               {
                    color: 'green lighten-2',
                    dark: true,
                    title: 'Bridesmaids Gifts',
                    icon: 'mdi-ring',
                    description: `Your bridesmaids are so much more than just part of your wedding. Give them gifts they will always remember`,
               },
               {
                    color: 'green lighten-2',
                    dark: true,
                    title: 'Graduation Gifts',
                    icon: 'mdi-school-outline',
                    description: `Graduation, at any level, is a big deal. While giving cash in a funny card may be easier, they deserve a Katink Trinket.`,
               },
               {
                    color: 'green lighten-2',
                    dark: true,
                    title: 'Thank You Gifts',
                    icon: 'mdi-hand-heart-outline',
                    description: `Sometimes finding the right thank you gift is difficult.  You don't want to spend too much but want them to know how thankful you really are.`,
               },
               {
                    color: 'green lighten-2',
                    dark: true,
                    title: 'Teachers Gift',
                    icon: 'mdi-teach',
                    description: `As a teacher, I know we love when our students give us gifts at the end of the year.  It's a child's way of showing how much they appreciate us.`,
               },
               {
                    color: 'green lighten-2',
                    dark: true,
                    title: 'For No Reason At All',
                    icon: 'mdi-human-handsup',
                    description: `You don't always need a reason to buy someone a gift.  It's perfectly normal to give someone (or yourself) a gift just because.`,
               },
          ],
     }),
}
</script>
